<template>
    <div>
        <h5>entered</h5>
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    created(){
 let id = this.$route.params.id;
    // console.log("id received", this.id);
    let data = {
        id
    }
     APIService.gettestdataById(data).then((res) => {
        if (res.status == 200) {
          console.log("resdata", res.data);
          this.tableData = res.data
        }
      });
    }
}
</script>